import _export from "../internals/export";
import _globalThis2 from "../internals/global-this";
import _schedulersFix from "../internals/schedulers-fix";
var $ = _export;
var _globalThis = _globalThis2;
var schedulersFix = _schedulersFix;
var setInterval = schedulersFix(_globalThis.setInterval, true);

// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$({
  global: true,
  bind: true,
  forced: _globalThis.setInterval !== setInterval
}, {
  setInterval: setInterval
});
export default {};